export default __webpack_public_path__ + "static/media/add-icon.89261cf5.svg";